@if (isAuthenticated) {
  <div class="page-wrap" [lxResponsiveClass]="pageResponsiveClass">
    <!-- Theme Controls - Same position as commented code in ui-new-shell -->
    <app-theme-controls></app-theme-controls>
    <app-theme-playground></app-theme-playground>
    <ui-new-shell [theme]="theme" [style]="style">
      <ui-new-top-bar
        [logoUrl]="logoUrl"
        (refreshClicked)="onRefresh()"
        (logoRendered)="onLogoRendered()">
      </ui-new-top-bar>

      <ui-new-tabs-bar
        [upgradeAvailability]="upgradeAvailability"
        [selectedTab]="selectedTab"
        [endDate]="endDate"
        [viewMode]="viewMode"
        [showCart]="false"
        [offerCount]="offerCount"
        (selectedTabChange)="onTabChanged($event)"
        (viewModeChange)="onViewModeChange($event)"
      ></ui-new-tabs-bar>

      <div class="offers-wrapper" data-theme-key="--bg-card-alt">
        @if (loadingPage) {
          <div class="inline-loading-panel" aria-live="polite">
            <div class="inline-loading-indicator">
              <div class="inline-loading-spinner" aria-hidden="true">
                <span class="spinner-arc spinner-arc-outer"></span>
                <span class="spinner-arc spinner-arc-inner"></span>
              </div>
              <div class="inline-loading-text">Loading...</div>
            </div>
          </div>
        }

        @if (!loadingPage) {
          <ng-container>
            <div class="offers" [class.tiles]="viewMode === 'tiles'" [class.list]="viewMode === 'list'">
              <ng-container
                *ngComponentOutlet="
                  uiNewOfferListComponent;
                  inputs: {
                    requestOnlyMode: requestOnlyMode,
                    activeOfferType: selectedTab,
                    viewMode: viewMode,
                    offers: (offers$ | async)
                  }
                "
              ></ng-container>
            </div>

            <ui-new-view-bar
              [hasOffers]="offers.length > 0"
              [selectedTab]="selectedTab"
              [viewMoreToggle]="false"
              [viewMoreOrLessText]="''"
              [offers]="offers"
              [offerCount]="offerCount"
            ></ui-new-view-bar>
          </ng-container>
        }
      </div>

    </ui-new-shell>

    <footer class="main-footer">
      Theme Configuration - Sample Data Display
    </footer>
  </div>
}
